import styled, { keyframes } from "styled-components";

interface INav {
    open: boolean;
    href?: string;
    dimensions?: {
        width: number;
        height: number;
    };
}

interface IBurguer extends INav {
    dimensions: {
        width: number;
        height: number;
    };
}

const fadeIn = keyframes`
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
`;

export const ContainerFade = styled.div`
    animation: ${fadeIn} 2s;
    height: 9%;
    align-self: center;
    display: inline-flex;
    justify-content: space-between;
    width: 95%;
    border-bottom: 1px solid black;
    align-items: center;

    @media (max-width: 768px) {
        height: 8%;
    }
`;

export const StyledBurger = styled.div<IBurguer>`
    height: ${(props) => (props.dimensions.height * 4) / 100}px;
    z-index: 20;
    margin: 2%;
    display: none;

    @media (max-width: 768px) {
        display: flex;
        justify-content: space-around;
        flex-flow: column nowrap;
    }
    div {
        width: ${(props) => (props.dimensions.height * 4) / 100}px;
        height: 0.25rem;
        background-color: ${(props) => (props.open ? "#000" : "#000")};
        border-radius: 10px;
        transform-origin: 1px;
        transition: all 0.3s linear;
        cursor: pointer;
        &:nth-child(1) {
            transform: ${(props) =>
                props.open ? "rotate(45deg)" : "rotate(0)"};
        }
        &:nth-child(2) {
            transform: ${(props) =>
                props.open ? "translateX(100%)" : "translateX(0)"};
            opacity: ${(props) => (props.open ? 0 : 1)};
        }
        &:nth-child(3) {
            transform: ${(props) =>
                props.open ? "rotate(-45deg)" : "rotate(0)"};
        }
    }
`;

export const Nav = styled.nav`
    display: flex;
    justify-content: flex-start;
    background-color: #fdfdfdfa;
    align-items: center;
    position: relative;
    border-bottom: 1px solid cadetblue;
    height: 100%;

    @media (max-width: 678px) {
        width: 100vw;
    }

    span {
        font-size: 30px;
        @media only screen and (max-width: 600px) {
            font-size: 20px;
            :nth-child(2) {
                font-size: 16px !important;
                margin-top: 0px !important;
            }
        }
    }
`;

export const Ul = styled.ul<INav>`
    list-style: none;
    display: flex;
    flex-flow: row nowrap;
    width: 60%;
    justify-content: flex-end;
    font-size: 17px;
    white-space: nowrap;

    a {
        text-decoration: none;
        text-transform: none;
        color: #000;
        cursor: pointer;

        &:hover {
            color: #0dadea;
        }
    }

    li {
        padding: 18px 10px;
    }

    @media (max-width: 768px) {
        flex-flow: column nowrap;
        background-color: #fdfdfdfa;
        position: fixed;
        transform: ${(props) =>
            props.open ? "translateX(0)" : "translateX(100%)"};
        top: -16px;
        right: 0;
        height: 100%;
        width: 160px;
        padding-top: 3.5rem;
        transition: transform 0.3s ease-in-out;
        z-index: 9;
        justify-content: normal;

        li {
            margin-right: 34px;

            &:hover {
                color: #0dadea;
            }
        }
    }
`;

export const Logo = styled.img`
    margin: 1vw 1vw 1vw 1%;
    width: 160px;
    height: 70px;
    object-fit: contain;

    @media (max-width: 1250px) {
        margin: 1vw 1vw 1vw 1%;
    }
`;

export const LogoUl = styled.img`
    margin: 20px 50px 20px 5%;
    display: none;

    @media (max-width: 768px) {
        display: flex;
        width: 160px;
        height: 70px;
        object-fit: contain;
    }
`;

export const Icon = styled.div`
    width: 100vw;
    height: calc(100vh - 112px);
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 150px;
        height: 150px;
        pointer-events: none;
        object-fit: contain;

        @media (prefers-reduced-motion: no-preference) {
            animation: App-logo-spin infinite 20s linear;
        }
    }

    @keyframes App-logo-spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export const Profile = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
        border-radius: 50%;
        width: 2.5em;
        height: auto;
        object-fit: contain;

        @media (max-width: 768px) {
            width: 45%;
            padding: 5px;
        }
    }

    @media (max-width: 768px) {
        align-items: baseline;
    }

    span {
        font-size: 0.8em;
        font-weight: bold;
    }
`;
